import type { HelpFile } from '../../types/help'
import { NotificationTemplateDetailTestIds } from '../../../testids/NotificationTemplateDetailTestIds'

export const notificationTemplateDetailHelp: HelpFile = {
  docPage: '/docs/admin/notification-templates',
  texts: {
    [NotificationTemplateDetailTestIds.notificationTemplateDetailPage]:
      'Bearbeiten Sie Betreff, Inhalt, Titel und Nachricht dieser Benachrichtigungsvorlage. Beim Speichern wird eine Datenbank-Anpassung erstellt; „Standard wiederherstellen" setzt auf die ausgelieferte Classpath-Vorlage zurück.',
    [NotificationTemplateDetailTestIds.cardNotificationTemplateMetadata]: null,
    [NotificationTemplateDetailTestIds.cardTitleEditor]:
      'Bearbeiten Sie Betreff, Inhalt, Titel und Nachricht. Verwenden Sie die Variablenauswahl, um Thymeleaf-Token in den Inhalt einzufügen.',
    [NotificationTemplateDetailTestIds.badgeCustomised]:
      'Zeigt an, ob eine Datenbank-Anpassung diese Vorlage überschreibt („Angepasst") oder der ausgelieferte Standard verwendet wird („Standard").',
    [NotificationTemplateDetailTestIds.badgeDefault]: null,
    [NotificationTemplateDetailTestIds.inputSubject]:
      'Die Betreffzeile der E-Mail. Thymeleaf-Variablen wie [[${requesterName}]] werden beim Versand ersetzt.',
    [NotificationTemplateDetailTestIds.textareaBody]:
      'Der HTML-Inhalt der E-Mail. Fügen Sie Variablen aus der Auswahl rechts an der Cursorposition ein.',
    [NotificationTemplateDetailTestIds.inputTitle]:
      'Optionaler Titel der In-App-Benachrichtigung.',
    [NotificationTemplateDetailTestIds.textareaMessage]:
      'Optionale Nachricht der In-App-Benachrichtigung.',
    [NotificationTemplateDetailTestIds.variablePicker]:
      'Für diesen Ereignistyp deklarierte Variablen. Klicken Sie auf eine, um ihren Thymeleaf-Token an der Cursorposition im Inhalt einzufügen.',
    [NotificationTemplateDetailTestIds.btnSave]: null,
    [NotificationTemplateDetailTestIds.btnCancel]: null,
    [NotificationTemplateDetailTestIds.btnRestoreDefault]:
      'Löscht die Datenbank-Anpassung, sodass die Vorlage auf den ausgelieferten Classpath-Standard zurückgesetzt wird.',
    [NotificationTemplateDetailTestIds.btnTestSend]:
      'Rendert die Vorlage mit Beispielvariablen und sendet eine Testnachricht an Ihre eigene E-Mail-Adresse.',
    [NotificationTemplateDetailTestIds.dialogRestoreDefault]: null,
  },
}
